import axios from "axios";
import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const Ekskul = () => {
  const [ekskuls, setEkskuls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchEkskuls = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/ekskul`);
        setEkskuls(response.data);
      } catch {
        setError("Gagal mengambil data ekskul.");
      } finally {
        setLoading(false);
      }
    };

    fetchEkskuls();
  }, [BASE_URL]);

  if (loading)
    return (
      <div className="text-center py-20 text-gray-500 dark:text-gray-300">
        Loading...
      </div>
    );

  if (error)
    return <div className="text-center py-20 text-red-500">{error}</div>;

  const displayedEkskuls = ekskuls.slice(0, 3);
  const getMediaUrl = (filename) => `${BASE_URL}api/ekskul/media/${filename}`;

  return (
    <section className="w-full py-16 px-4 bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto">
        {/* Judul */}
        <h1 className="text-center text-3xl md:text-4xl font-extrabold text-blue-600 dark:text-yellow-400 mb-12">
          Ekstrakurikuler
        </h1>

        {displayedEkskuls.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {displayedEkskuls.map((ekskul) => (
              <div
                key={ekskul._id}
                className="
                  bg-white dark:bg-gray-800
                  rounded-2xl
                  shadow-md
                  hover:shadow-xl
                  transition-all duration-300
                  overflow-hidden
                  flex flex-col
                "
              >
                {/* Media */}
                <div className="h-48 w-full bg-gray-200 dark:bg-gray-700">
                  {ekskul.Gambar?.filename ? (
                    ekskul.Gambar.mimetype?.startsWith("image/") ? (
                      <img
                        src={getMediaUrl(ekskul.Gambar.filename)}
                        alt={ekskul.Judul}
                        className="w-full h-full object-cover"
                      />
                    ) : ekskul.Gambar.mimetype?.startsWith("video/") ? (
                      <video
                        src={getMediaUrl(ekskul.Gambar.filename)}
                        className="w-full h-full object-cover"
                        autoPlay
                        loop
                        muted
                      />
                    ) : (
                      <div className="h-full flex items-center justify-center text-sm text-gray-500">
                        Format tidak didukung
                      </div>
                    )
                  ) : (
                    <div className="h-full flex items-center justify-center text-sm text-gray-400">
                      Tidak ada media
                    </div>
                  )}
                </div>

                {/* Konten */}
                <div className="flex flex-col flex-1 p-6">
                  <h2 className="text-lg font-bold text-gray-800 dark:text-white mb-4">
                    {ekskul.Judul}
                  </h2>

                  <button
                    onClick={() => navigate(`/ekskul-satu/${ekskul._id}`)}
                    className="
                      mt-auto
                      bg-gradient-to-r from-blue-500 to-purple-500
                      hover:from-purple-500 hover:to-blue-500
                      text-white
                      px-5 py-2
                      rounded-full
                      text-sm font-semibold
                      shadow
                      transition-all
                    "
                  >
                    Lihat Informasi
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-gray-600 dark:text-gray-300">
            Tidak ada ekskul ditemukan.
          </p>
        )}

        {/* Tombol lihat semua */}
        <div className="flex justify-center mt-14">
          <Link to="/ekskul">
            <button
              className="
                flex items-center gap-3
                bg-yellow-400 hover:bg-yellow-500
                text-gray-900
                px-8 py-3
                rounded-full
                font-bold
                shadow-lg
                transition-all duration-300
              "
            >
              Lihat Semua Ekskul
              <FaArrowRight />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Ekskul;
